// extracted by mini-css-extract-plugin
export default {"moreLink":"MoreLink__moreLink___ZOCII"};